function brand() {
  let body = document.body;

  if(typeof body.dataset == 'undefined' || typeof document.body.dataset.brand == 'undefined') {
    return null
  }

  return body.dataset.brand;
}

function locationAware() {
  //if (brand === 'group-first' || brand === 'business-first' || brand === 'white-hill-stud' || brand === 'supashed' || brand === 'northlight-estates') {
  //  return false;
  //}

  return false;
}

export default {
  brand : brand,
  locationAware : locationAware
};
